import axios from 'axios';

function OverlayShape(data) {
  this.Id = data.Id;
  this.OverlayId = data.OverlayId;
  this.Name = data.Name;
  this.Geometry = data.Geometry;
  this.Color = data.Color;
}


OverlayShape.prototype = {
  constructor: OverlayShape

};


OverlayShape.find = function(ids) {
  var deferred = $.Deferred();

  if(!Array.isArray(ids)){
    ids = [ids];
  }

  var filter = "Id Eq " + ids.join(',')

  axios.get(window.routes.shapes_overlays_path(), {
    params: {_filter: filter}
  }).then((response) => {
    var shapes = [];
    response.data.forEach(function(shape) {
      shapes.push(new OverlayShape(shape));
    });
    deferred.resolve(shapes);    
  });

  return deferred;
}

export default OverlayShape;
